import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const footerLinks = {
    company: [
      { name: 'About Us', link: '#about' },
      { name: 'Our Services', link: '#services' },
      { name: 'Contact Us', link: '#contact' }
    ],
    services: [
      { name: 'Temperature Monitoring', link: '#services' },
      { name: 'Wireless Controllers', link: '#services' },
      { name: 'Industrial Solutions', link: '#services' },
      { name: 'HVAC Systems', link: '#services' }
    ],
    support: [
      { name: 'Installation', link: '#' },
      { name: 'Technical Support', link: '#contact' },
      { name: 'Maintenance', link: '#' }
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: '💼', link: '#' },
    { name: 'Twitter', icon: '🐦', link: '#' },
    { name: 'Facebook', icon: '📘', link: '#' },
    { name: 'YouTube', icon: '📺', link: '#' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <div className="brand-info">
              <img src="/images/logo.png" alt="Company Logo" className="footer-logo" />
             
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>C-10/189, Sector-5, Rohini, Delhi-110085</span>
              </div>
             
              <div className="contact-item">
                <span className="contact-icon">📱</span>
                <span> 9013799987, 9871757312</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <span>sales@alphatechcloud.in</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a href={link.link}>{link.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a href={link.link}>{link.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a href={link.link}>{link.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 alphatechcloud. All rights reserved.</p>
            </div>
            <div className="footer-bottom-links">
              <button 
                className="login-link"
                onClick={() => navigate('/client-login')}
              >
                Client Login
              </button>
              <span className="separator">|</span>
              <a href="#contact">Support</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
